// DS8.2.1 Simple Footer
import React from 'react';
import c from 'classnames';
import BrandedButton from '../../Buttons/BrandedButton';
import s from './PopoverSimpleFooter.scss';
const PopoverSimpleFooter = ({ message, label, biData, href, onClick })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'])
    }, message && /*#__PURE__*/ React.createElement("div", {
        className: s['message']
    }, message), label && /*#__PURE__*/ React.createElement(BrandedButton, {
        size: "medium",
        variant: "brand-green",
        onClick: onClick,
        fillContainerWidth: true,
        biData: biData,
        href: href,
        className: s['button']
    }, label));
};
PopoverSimpleFooter.displayName = 'PopoverSimpleFooter';
export default PopoverSimpleFooter;
